var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98.7556,
    height: 119.76,
    viewBox: "96.187 52.2402 98.7556 119.76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.943 143.248C190.943 144.353 190.047 145.248 188.943 145.248H176.985C175.88 145.248 174.985 146.144 174.985 147.248V166C174.985 167.105 174.089 168 172.985 168H154.865C153.76 168 152.865 167.105 152.865 166V147.248C152.865 146.144 151.969 145.248 150.865 145.248H102.245C101.346 145.248 100.558 144.649 100.318 143.784L96.26 129.176C96.0872 128.553 96.2254 127.886 96.6312 127.384L155.108 54.9836C155.488 54.5135 156.06 54.2402 156.664 54.2402H172.985C174.089 54.2402 174.985 55.1357 174.985 56.2402V123.024C174.985 124.129 175.88 125.024 176.985 125.024H188.943C190.047 125.024 190.943 125.92 190.943 127.024V143.248ZM126.324 121.791C125.296 123.104 126.231 125.024 127.899 125.024H150.865C151.969 125.024 152.865 124.129 152.865 123.024V93.6928C152.865 91.7917 150.462 90.963 149.29 92.4598L126.324 121.791Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.943 143.248C190.943 144.353 190.047 145.248 188.943 145.248H176.985C175.88 145.248 174.985 146.144 174.985 147.248V166C174.985 167.105 174.089 168 172.985 168H154.865C153.76 168 152.865 167.105 152.865 166V147.248C152.865 146.144 151.969 145.248 150.865 145.248H102.245C101.346 145.248 100.558 144.649 100.318 143.784L96.26 129.176C96.0872 128.553 96.2254 127.886 96.6312 127.384L155.108 54.9836C155.488 54.5135 156.06 54.2402 156.664 54.2402H172.985C174.089 54.2402 174.985 55.1357 174.985 56.2402V123.024C174.985 124.129 175.88 125.024 176.985 125.024H188.943C190.047 125.024 190.943 125.92 190.943 127.024V143.248ZM126.324 121.791C125.296 123.104 126.231 125.024 127.899 125.024H150.865C151.969 125.024 152.865 124.129 152.865 123.024V93.6928C152.865 91.7917 150.462 90.963 149.29 92.4598L126.324 121.791Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter04",
    x: 96.187,
    y: 52.2402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 143.464,
    y1: 54.2402,
    x2: 209.005,
    y2: 150.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e8378e6868986e72de0f4f56c4c00752.svg";
export { ForwardRef as ReactComponent };